export default `
  mutation updateTeamMemberLastLogin($id: String!, $projectId: String!) {
    updateTeamMemberLastLogin(id: $id, projectId: $projectId) {
      id
      projectId
      lastLogin
      createdAt
    }
  }
`
